import React from 'react'

import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap'
import cx from 'classnames'

import ButtonIcon from './ButtonIcon'
import CardBodyCollapse from './CardBodyCollapse'

export default ({
  children,
  title,
  actions,
  footer,
  className,
  titleClassName,
  bodyClassName,
  footerClassName,
  actionClassName,
  outline,
  fieldset,
  color,
  titleLeft,
  titleCenter,
  cardBodyCollapse,
  defaultIsBodyOpen,
  cardBodyToggleButtonClassName,
  cardBodyToggleIconClassName,
  ...props
}) => {
  const [isBodyOpen, setisBodyOpen] = React.useState(defaultIsBodyOpen)
  const toggle = () => {
    if (cardBodyCollapse) setisBodyOpen(prev => !prev)
  }
  const TitleTag = fieldset ? 'h4' : 'h5'

  return (
    <Card
      className={cx(className, outline && 'card-outline', fieldset && 'fieldset')}
      outline={outline}
      color={color}
      {...props}
    >
      {title && (
        <CardHeader className={cx(titleClassName, !fieldset && color && `alert alert-${color} px-4 py-2`)}>
          {cardBodyCollapse && (
            <ButtonIcon
              icon={isBodyOpen ? 'indeterminate_check_box' : 'add_box'}
              className={cx(cardBodyToggleButtonClassName,"p-1")}
              iconClassName={cx(cardBodyToggleIconClassName)}
              onClick={toggle}
            />
          )}
          <TitleTag className="card-header-title">{title}</TitleTag>
          {actions && <div className={cx('card-header-actions', actionClassName)}>{actions}</div>}
        </CardHeader>
      )}
      {cardBodyCollapse && (
        <CardBodyCollapse bodyClassName={bodyClassName} isBodyOpen={isBodyOpen}>
          {children}
        </CardBodyCollapse>
      )}
      {!cardBodyCollapse && <CardBody className={cx(bodyClassName)}>{children}</CardBody>}
      {footer && <CardFooter className={cx(footerClassName)}>{footer}</CardFooter>}
    </Card>
  )
}
